export default 'referral'
